import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from 'app/core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  private _data: BehaviorSubject<any> = new BehaviorSubject(null);
  private dataStore: { bookings: any[] } = { bookings: [] };

  constructor(private _httpClient: HttpClient, private _apiService: ApiService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for data
   */
  get data$(): Observable<any> {
    return this._data.asObservable();
  }

  /**
   * Getter for stored bookings
   */
  get(): any {
    return this.dataStore.bookings;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Search bookings by raw criteria
   * @param searchData The search criteria for the booking search
   */
  searchBookings(searchData: any): Observable<any> {
    return this._apiService.post('booking/search/raw', searchData).pipe(
      tap((bookings: any) => {
        this.dataStore.bookings = bookings;
        this._data.next(bookings);
      })
    );
  }

  /**
   * Search bookings audit with user details and amounts
   * @param searchData The search criteria for the booking audit
   */
  searchBookingsAudit(searchData: any): Observable<any> {
    return this._apiService.post('booking/search/audit', searchData).pipe(
      tap((bookings: any) => {
        this.dataStore.bookings = bookings;
        this._data.next(bookings);
      })
    );
  }

  /**
   * Export bookings to CSV
   * @param searchData The search criteria for the booking export
   */
  exportBookingsToCSV(searchData: any): Observable<any> {
    return this._apiService.postDownload<Blob>('booking/export/csv', searchData, {
      responseType: 'blob' as 'json' // TS hint so HttpClient accepts it
    });
  }
}